import { OnInit } from '@angular/core';
import { AssessmentResult } from '../../../shared/models/assessment-result';
var SummarySectionGraphItemComponent = /** @class */ (function () {
    function SummarySectionGraphItemComponent() {
    }
    SummarySectionGraphItemComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(SummarySectionGraphItemComponent.prototype, "PCLSummaryScaleResult", {
        get: function () {
            if (this.scaleResults && this.scaleResults.length) {
                return this.scaleResults[0]; // first and only item for the PCL
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SummarySectionGraphItemComponent.prototype.getRangeNameForFirstScaleResult = function (scaleResults) {
        if (scaleResults && scaleResults.length >= 1
            && scaleResults[0].range) {
            return scaleResults[0].range.displayName;
        }
        return "";
    };
    SummarySectionGraphItemComponent.prototype.getClasses = function (item) {
        if (item.chartSize) {
            var result = "p-" + item.chartSize + "-chart";
            return [result];
        }
        else {
            return ["p-small-chart"];
        }
    };
    return SummarySectionGraphItemComponent;
}());
export { SummarySectionGraphItemComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/summary-section-graph-item/summary-section-graph-item.component.ts.pre-build-optimizer.js